<div mat-dialog-content style="width: 350px">
  <lemon-dialog-header> Lisää tiedosto </lemon-dialog-header>

  <form>
    <div style="margin: 2rem">
      <div style="margin: 2rem 0">
        @if (!uploadedFile()?.fileName) {
          <app-primary-button (click)="fileInput.click()" actionId="Valitse tiedosto ladattavaksi arkistoon"> Valitse tiedosto </app-primary-button>
        } @else {
          <div>{{ uploadedFile()?.fileName }}</div>
        }
      </div>

      @if (latausVirheObservable | async; as latausVirhe) {
        <div class="error-box">{{ latausVirhe }}</div>
      }

      <mat-form-field>
        <mat-label>Lisätiedot</mat-label>
        <input [formField]="lomake.lisatiedot" matInput data-lpignore="true" />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <app-secondary-button mat-dialog-close actionId="Peruuta (sisäiseen arkistoon lataus dialog)" styles="margin-right: 20px;">Peruuta</app-secondary-button>
  <app-primary-button [disabled]="!uploadedFile()" (click)="save()" actionId="Tallennettu tiedosto sisäiseen arkistoon" [actionContext]="[uploadedFile()?.fileName]">Tallenna</app-primary-button>
</div>

<input style="visibility: hidden; height: 1px" (change)="upload($event)" type="file" accept="*" #fileInput multiple="multiple" />
